
export class UserProfile {
    public username:string | undefined;
    public firstname:string | undefined;
    public lastname:string | undefined;
    public email:string|undefined;
    public userid:number|undefined;
    public permissions:Array<string>|undefined;
}

export default class User {
    public IsLoggedIn():boolean {
        var exp = localStorage.getItem('expires');
        if(exp) {
            return (new Date()) < new Date(exp);
        }

        return false;
    }

    public HasPermission(perm:string): boolean {
        //Note! Does not check IsLoggedIn!
        if(!perm)
            return true;

        var ps = perm.split(',');
        if(ps.length>1) {
            return ps.some(p => this.HasPermission(p));
        }
        
        var usr = this.GetUser();                
        if(usr.permissions) {
            var perms = perm.split(',');
            return (usr.permissions?.some(p => perms.indexOf(p.toUpperCase()) >= 0));
        }
            
        
        return false;
    }

    public GetUser():UserProfile {
        var usr = localStorage.getItem('user');
        if(!usr)
            return new UserProfile();

        return JSON.parse(usr);
    }    
}
